import { render } from "./Boolean.vue?vue&type=template&id=01af5eb6&lang=pug"
import script from "./Boolean.vue?vue&type=script&lang=ts"
export * from "./Boolean.vue?vue&type=script&lang=ts"
script.render = render

export default script